export default "__VITE_ASSET__Ckf3D3sj__"